import { useQuery } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getActivityLogKey } from '../../utils/keys';
export const useActivityLogs = (options) => {
    const { variables, fields = 'basic', useQueryOptions } = options;
    const { client } = useTribeClient();
    const activityLogKey = getActivityLogKey(variables);
    return useQuery(activityLogKey, () => client.report.activityLogs(variables, fields), useQueryOptions);
};
//# sourceMappingURL=useActivityLogs.js.map